import { useContext, useEffect, useState } from "react";
import {
	Row,
	Col,
	Table,
	Button,
	Popconfirm,
	Tag,
	Flex,
	Form,
	Tooltip,
} from "antd";
import { useParams } from "react-router-dom";

import {
	TableGlobalSearchAnimated,
	TablePageSize,
	TablePagination,
	TableShowingEntriesV2,
	useTableScrollOnTop,
} from "../../../../providers/CustomTableFilter";

import ModalFormExamSheetNumber from "./ModalFormExamSheetNumber";
import ModalAuthPassword from "./ModalAuthPassword";
import ModalExamStatusReport from "./ModalExamStatusReport";
import dayjs from "dayjs";
import PageApplicantContext from "./PageApplicantContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-regular-svg-icons";

export default function TableExamStatus() {
	const {
		tableFilter,
		setTableFilter,
		location,
		dataStudentExam,
		dataExamCategory,
	} = useContext(PageApplicantContext);

	// console.log("tableFilter TableExamStatus: ", tableFilter);

	const params = useParams();
	const [form] = Form.useForm();

	// Open Modal Form Exam Answersheet Number
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [
		toggleModalFormExamSheetNumber,
		setToggleModalFormExamSheetNumber,
	] = useState({
		open: false,
		data: null,
	});

	const [toggleModalAuthPassword, setToggleModalAuthPassword] = useState({
		open: false,
		data: null,
	});

	const [
		toggleModalExamStatusReport,
		setToggleModalExamStatusReport,
	] = useState({
		open: false,
		data: null,
	});

	useEffect(() => {
		if (tableFilter.isTrash === 1) {
			setTableFilter((prev) => ({
				...prev,
				isTrash: 0,
			}));
		}
	}, [tableFilter.isTrash]);

	useTableScrollOnTop("tblExamResult", location.pathname);

	return (
		<>
			<Row gutter={[12, 12]} id="tbl_wrapper_examresult">
				<Col xs={24} sm={24} md={24} lg={24}>
					<div className="tbl-top-filter">
						<Flex gap={10} vertical>
							<Flex gap={10}>
								<Tooltip
									title={
										tableFilter.exam_schedule_id === "All" ||
										tableFilter.exam_schedule_id === ""
											? "Filter Exam Schedule"
											: ""
									}
								>
									<Button
										type={
											tableFilter.exam_schedule_id === "All" ||
											tableFilter.exam_schedule_id === ""
												? "default"
												: "primary"
										}
										icon={<FontAwesomeIcon icon={faDownload} />}
										iconPosition="end"
										onClick={() => {
											setToggleModalExamStatusReport({
												open: true,
												data: {
													exam_schedule_id: tableFilter.exam_schedule_id,
													category: tableFilter.category,
												},
											});
										}}
										disabled={
											tableFilter.exam_schedule_id === "All" ||
											tableFilter.exam_schedule_id === ""
										}
									>
										Export PDF
									</Button>
								</Tooltip>
							</Flex>

							<Flex gap={10}>
								<Button
									type={
										tableFilter.exam_status === "Not Taken"
											? "primary"
											: "default"
									}
									onClick={() => {
										setTableFilter((ps) => ({
											...ps,
											exam_status: "Not Taken",
										}));
										setSelectedRowKeys([]);
									}}
									className={
										tableFilter.exam_status === "Not Taken" &&
										"btn-main-primary"
									}
								>
									Not Taken
								</Button>

								<Button
									type={
										tableFilter.exam_status === "Taken" ? "primary" : "default"
									}
									onClick={() => {
										setTableFilter((ps) => ({
											...ps,
											exam_status: "Taken",
										}));
										setSelectedRowKeys([]);
									}}
									className={
										tableFilter.exam_status === "Taken" && "btn-main-primary"
									}
								>
									Taken
								</Button>

								{selectedRowKeys.length > 0 && (
									<Popconfirm
										title={
											<>
												Are you sure you want to
												<br /> update the selected{" "}
												{selectedRowKeys.length > 1
													? "exam statuses"
													: "exam status"}
												<br />
												to{" "}
												{tableFilter.exam_status === "Not Taken"
													? "taken"
													: "checked"}
												?
											</>
										}
										okText="Yes"
										cancelText="No"
										disabled={selectedRowKeys.length === 0}
										onConfirm={() => {
											if (tableFilter.exam_status === "Not Taken") {
												setToggleModalFormExamSheetNumber({
													open: true,
													exam_schedule_id: params.id,
													ids: selectedRowKeys,
													status: tableFilter.exam_status,
												});
											} else {
												let data = dataStudentExam.data.data.filter((item) =>
													selectedRowKeys.includes(item.id)
												);

												setToggleModalAuthPassword({
													open: true,
													data: data,
												});
											}
										}}
									>
										<Button
											type="primary"
											className="btn-main-primary outlined"
										>
											Update Status to{" "}
											{tableFilter.exam_status === "Not Taken"
												? "Taken"
												: "Checked"}
										</Button>
									</Popconfirm>
								)}
								<TableGlobalSearchAnimated
									tableFilter={tableFilter}
									setTableFilter={setTableFilter}
								/>
							</Flex>
						</Flex>

						<Flex vertical gap={12} align="flex-end">
							<TablePageSize
								tableFilter={tableFilter}
								setTableFilter={setTableFilter}
							/>

							<Flex className="tbl-bottom-filter">
								<div />

								<Flex>
									<TableShowingEntriesV2 />
									<TablePagination
										tableFilter={tableFilter}
										setTableFilter={setTableFilter}
										setPaginationTotal={dataStudentExam?.data?.total}
										showLessItems={true}
										showSizeChanger={false}
										tblIdWrapper="tbl_wrapper_approval"
									/>
								</Flex>
							</Flex>
						</Flex>
					</div>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24}>
					<Table
						id="tblExamResult"
						className="ant-table-default ant-table-striped"
						dataSource={dataStudentExam && dataStudentExam.data.data}
						rowKey={(record) => record.id}
						pagination={false}
						bordered={false}
						scroll={{ x: "max-content" }}
						sticky
						rowSelection={
							tableFilter.exam_status === "Not Taken"
								? {
										selectedRowKeys,
										onChange: (selectedRowKeys) => {
											setSelectedRowKeys(selectedRowKeys);
										},
								  }
								: null
						}
						onChange={(pagination, filters, sorter) => {
							setTableFilter((prev) => ({
								...prev,
								category: filters.exam_category ?? [
									"College",
									"College of Law",
									"Graduate Studies",
								],
							}));
						}}
					>
						{tableFilter.exam_status === "Taken" && (
							<>
								<Table.Column
									title="Answer Sheet Number"
									key="exam_sheet_number"
									dataIndex="exam_sheet_number"
									sorter={(a, b) => a.exam_sheet_number - b.exam_sheet_number}
									render={(text, record) => {
										// console.log("record:", record);
										return <>{record.answer_sheet_no}</>;
									}}
									width={200}
								/>

								<Table.Column
									title="Date Taken"
									key="date_taken"
									dataIndex="date_taken"
									sorter={(a, b) => a.date_taken - b.date_taken}
									render={(text, record) => {
										return (
											<>{dayjs(record.date_taken).format("MMMM DD, YYYY")}</>
										);
									}}
									width={200}
								/>
							</>
						)}

						<Table.Column
							title="Student Name"
							key="fullname"
							dataIndex="fullname"
							sorter={(a, b) => a.fullname.localeCompare(b.fullname)}
							width={200}
							render={(text, record) => {
								const fullname = record.fullname;
								return <>{` ${fullname} `}</>;
							}}
						/>

						<Table.Column
							title="Exam Schedule"
							key="exam_schedule_id"
							dataIndex="exam_schedule_id"
							sorter={(a, b) => a.exam_category.localeCompare(b.exam_category)}
							defaultSortOrder="ascend"
							width={300}
							render={(text, record) => (
								<>
									{dayjs(record.exam_date).format("MMMM DD, YYYY")} ({" "}
									{record.exam_time} )
								</>
							)}
						/>

						<Table.Column
							title="Exam Category"
							key="exam_category"
							dataIndex="exam_category"
							sorter={(a, b) => a.exam_category - b.exam_category}
							width={200}
							render={(text, record) => (
								<>
									{record.exam_category}{" "}
									<Tag color="blue" style={{ fontSize: "12px" }}>
										₱ {record.exam_fee}.00
									</Tag>
								</>
							)}
							filters={
								dataExamCategory
									? dataExamCategory.map((item) => ({
											text: item.category,
											value: item.category,
									  }))
									: []
							}
						/>

						<Table.Column
							title="Payment Status"
							key="payment_status"
							dataIndex="payment_status"
							sorter={(a, b) => a.payment_status - b.payment_status}
							width={150}
							render={(text, record) => {
								return (
									<Tag
										color={
											record.payment_status === "Not Paid" ? "#f50" : "#87d068"
										}
										style={{ fontSize: "12px" }}
									>
										{record.payment_status}
									</Tag>
								);
							}}
						/>
					</Table>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
					<Flex className="tbl-bottom-filter">
						<div />

						<Flex>
							<TableShowingEntriesV2 />
							<TablePagination
								tableFilter={tableFilter}
								setTableFilter={setTableFilter}
								setPaginationTotal={dataStudentExam?.data?.total}
								showLessItems={true}
								showSizeChanger={false}
								tblIdWrapper="tbl_wrapper_approval"
							/>
						</Flex>
					</Flex>
				</Col>
			</Row>

			<ModalFormExamSheetNumber
				toggleModalFormExamSheetNumber={toggleModalFormExamSheetNumber}
				setToggleModalFormExamSheetNumber={setToggleModalFormExamSheetNumber}
				dataSource={dataStudentExam}
				tableFilter={tableFilter}
				selectedRowKeys={selectedRowKeys}
				setSelectedRowKeys={setSelectedRowKeys}
				form={form}
			/>

			<ModalAuthPassword
				toggleModalAuthPassword={toggleModalAuthPassword}
				setToggleModalAuthPassword={setToggleModalAuthPassword}
				tableFilter={tableFilter}
			/>

			<ModalExamStatusReport
				tableFilter={tableFilter}
				toggleModalExamStatusReport={toggleModalExamStatusReport}
				setToggleModalExamStatusReport={setToggleModalExamStatusReport}
			/>
		</>
	);
}
